module.exports = __webpack_public_path__ + "img/empty.b83fa398.png";